const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/pages/edit/$id/settings/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/pages/edit/$id/settings")({
  beforeLoad: ({
    context,
    params
  }) => {
    const communitySettings = context.punditUserContext?.currentCommunitySettings;
    if (!communitySettings) {
      return;
    }
    if (!communitySettings.cms_builder_circle_ai_v1_enabled) {
      redirect({
        to: "/settings/pages/edit/$id",
        params: {
          id: params.id
        },
        replace: true,
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});